import React, { useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';
import ResultTracking from '@Services/ResultTracking';
import SubstanceDetailsModal from '@Components/Results/structure/substance-details/SubstanceDetailsModal';
import HoverTooltip from '@Components/HoverTooltip';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

import './SubstanceDetails.scss';

function SubstanceDetails({ trackingContext, structure, reactionId, tooltipId, metadata, trackingContent }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDetails = (open) => {
    setIsOpen(open);
    if (open) {
      ResultTracking.structureContentInteraction('view details', trackingContext, trackingContent);
      const tooltip = document.getElementById(tooltipId);
      if (tooltip) {
        tooltip.dispatchEvent(
          new MouseEvent('mouseleave', {
            bubbles: true,
          })
        );
      }
    }
  };

  const tooltipLabel = 'Show Details';
  return (
    <Flyout
      isControlled
      isOpen={isOpen}
      flyout={<SubstanceDetailsModal isOpen={isOpen} structure={structure} reactionId={reactionId} closeMenu={noop} metadata={metadata} />}
      shouldCloseOnESC
      showCloseButton
      onToggle={toggleDetails}
      placement="bottom-start"
      className="structure-toolbar-options"
      pointerType="primary">
      <HoverTooltip id={tooltipId} tooltip={tooltipLabel} tooltipPlace="top" theme="simple">
        <span id="view-details-button-description" className="sr-only">
          Overview of substance details with a link to the full record.
        </span>
        <ButtonWithIcon
          data-e2e="substance-details-link"
          sprite="TextFile"
          onClick={noop}
          iconOnly
          type="borderless"
          aria-expanded={isOpen}
          aria-describedby="view-details-button-description">
          View Details
        </ButtonWithIcon>
      </HoverTooltip>
    </Flyout>
  );
}

SubstanceDetails.propTypes = {
  trackingContext: PropTypes.string,
  structure: PropTypes.object.isRequired,
  reactionId: PropTypes.string,
  tooltipId: PropTypes.string,
  metadata: MetadataPropTypesShape,
  trackingContent: PropTypes.array,
};

export default SubstanceDetails;
